import authService                  from '../services/AuthService';
import userProfileDialogModel       from './UserProfileDialogModel';
import aboutDialogModel             from './AboutDialogModel';
import switchLocationDialog         from '../accounts/SwitchLocationsModel';
import mainPageModel                from '../main-navigation/MainPageModel';
import {
  RouteManagerBase,
}                                   from '../main-navigation/RouteManager';
import Routes                       from '../Routes';

export class UserOptionsMenuModel {
  constructor() {
  }

  get avatar(): string | undefined {
    return mainPageModel.avatar;
  }

  get userInitials(): string | undefined {
    return mainPageModel.userInitials;
  }

  // get locationName(): string | undefined {
  //   return mainPageModel.locationName;
  // }

  get testModeEnabled(): boolean {
    return mainPageModel.testModeEnabled;
  }

  showUserProfileDialog() {
    userProfileDialogModel.load();
  }

  showAboutDialog() {
    aboutDialogModel.load();
  }

  switchLocationDialog() {
    if (!this.canSwitchLocation) {
      return;
    }

    switchLocationDialog.load();
  }

  canSwitchLocation() {
    return mainPageModel.canSwitchLocation;
  }

  canToggleTestMode() {
    return mainPageModel.canToggleTestMode;
  }

  toggleTestMode() {
    mainPageModel.toggleTestMode();
    const currPath = RouteManagerBase.current.path;
    if (currPath === Routes.TimecardTest || currPath === Routes.Batch || currPath === Routes.BatchSummary) {
      RouteManagerBase.current.navigateTo();
    }
  }

  async logout(): Promise<boolean> {
    return await authService.logout();
  }
}

const userOptionsMenuModel = new UserOptionsMenuModel();
export default userOptionsMenuModel;
